const controls = [
  {
    identifier: 'navigation',
    position: 'top-right',
    options: {
      showCompass: false,
      showZoom: true,
    },
  },
  {
    identifier: 'geolocate',
    collapsed: false,
    position: 'top-right',
    options: {
      positionOptions: {
        enableHighAccuracy: true,
      },
      trackUserLocation: true,
    },
  },
  {
    identifier: 'location-search-placeholder',
    collapsed: false,
    position: 'top-right',
    options: {},
  },
  {
    identifier: 'layer-control',
    position: 'top-left',
    options: {},
  },
  {
    identifier: 'attribution',
    position: 'top-left',
    options: {
      compact: true,
      customAttribution: '<a href="https://nazka.be" rel="noopener" target="_blank">Nazka Mapps</a>',
    },
  },

]

export {
  controls,
}